module.exports = __webpack_public_path__ + "static/img/ban1.49b347b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/images/sports/ban1.jpg
// module id = 1qCn
// module chunks = 110